import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Compose class names, resolving Tailwind conflicts so the last value wins.
 * Matches the template's `cn()` helper (spec §6.5).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
